import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from 'ui/container'
import { useAuthContext } from '../../core/providers/AuthProvider'
import { formatNumbers } from 'core/helpers/format-numbers'
import { copyToClipboard } from 'core/helpers/copy-to-clipboard'
import { apiClient } from 'core/http'
import { toast } from 'react-toastify'
import { ProfileMenu } from 'features/profile/menu'
import avatar from 'features/header/assets/images/avatar.png'
import copyIcon from 'features/profile/user/assets/images/copy.svg'
import c from './assets/sass/page.module.scss'

const UserProfilePage = () => {
    const { t } = useTranslation()
    const { user, updateUserData } = useAuthContext()
    const [isEditing, setIsEditing] = useState(false)
    const [newSiteId, setNewSiteId] = useState('')
    const [isSaving, setIsSaving] = useState(false)

    const displayName = user?.username || user?.firstName || t('header.player')
    const userAvatar = user?.photoUrl || avatar
    const balance = parseInt(user?.balance) || 0
    const siteId = user?.siteId || ''

    const handleCopyId = () => {
        if (siteId) {
            copyToClipboard(siteId)
        }
    }

    const handleSaveId = async () => {
        if (!newSiteId.trim() || newSiteId.trim().length < 3) {
            toast(t('profile.user.error.idLength'), { type: 'error' })
            return
        }
        setIsSaving(true)
        try {
            const res = await apiClient.put('/user/site-id', { siteId: newSiteId.trim() })
            if (res?.data?.success) {
                toast(t('profile.user.error.idUpdated'), { type: 'success' })
                setIsEditing(false)
                setNewSiteId('')
                updateUserData()
            }
        } catch (e) {
            const code = e?.response?.data?.code
            if (code === 'SITE_ID_TAKEN') {
                toast(t('profile.user.error.idTaken'), { type: 'error' })
            } else {
                toast(t('profile.user.error.serverError'), { type: 'error' })
            }
        } finally {
            setIsSaving(false)
        }
    }

    return (
        <div className={c.component}>
            <Container>
                <div className={c.userCard}>
                    <div className={c.userTop}>
                        <img className={c.avatar} src={userAvatar} alt="" />
                        <div className={c.userInfo}>
                            <div className={c.userName}>{displayName}</div>
                            <div className={c.userBalance}>
                                <span>{formatNumbers(balance)}</span>
                            </div>
                            {siteId && (
                                <div className={c.userId} onClick={handleCopyId}>
                                    <span>ID {siteId}</span>
                                    <img src={copyIcon} alt="" />
                                </div>
                            )}
                        </div>
                        {!isEditing ? (
                            <button
                                className={c.changeIdBtn}
                                onClick={() => setIsEditing(true)}
                            >
                                {t('profileMenu.changeId')}
                            </button>
                        ) : (
                            <div className={c.editId}>
                                <input
                                    className={c.editInput}
                                    value={newSiteId}
                                    onChange={(e) => setNewSiteId(e.target.value)}
                                    placeholder={t('profile.user.placeholder')}
                                />
                                <button
                                    className={c.saveBtn}
                                    onClick={handleSaveId}
                                    disabled={isSaving}
                                >
                                    {t('profile.user.save')}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <ProfileMenu />
            </Container>
        </div>
    )
}

export default UserProfilePage
